<template>
  <div class="content-box">
    <div class="page-title">
      当前位置：首页 > 机构信息
    </div>
    <div class="content-info">
      <h3 class="form-title flex-center">
        机构信息
        <p>标 “ <b>*</b> ” 为必填项，已导入信息不可修改</p>
      </h3>

      <div class="form-step flex-center ">
        <span class="margin-right ">第一步：机构信息</span>
        <span class="active">第二步：设置网店</span>
      </div>
      <div class="margin flex-center around-box wd-list">
        <div class="wd-item" :class="{active:wdId === 1}">
          <i class="iconfont iconxuanzhong"></i>
          <img src="../../assets/img/1.jpg" alt="">
          <div>
            <router-link to="/commonts?id=1">预览</router-link>
            <el-button round type="primary" @click="wdId = 1">使用</el-button>
          </div>
        </div>
        <div class="wd-item" :class="{active:wdId === 2}">
          <i class="iconfont iconxuanzhong"></i>
          <img src="../../assets/img/2.jpg" alt="">
          <div>
            <router-link to="/commonts?id=2">预览</router-link>
            <el-button round type="primary" @click="wdId = 2">使用</el-button>
          </div>
        </div>
        <div class="wd-item" :class="{active:wdId === 3}">
          <i class="iconfont iconxuanzhong"></i>
          <img src="../../assets/img/3.jpg" alt="">
          <div>
            <router-link to="/commonts?id=3">预览</router-link>
            <el-button round type="primary" @click="wdId = 3">使用</el-button>
          </div>
        </div>
        <div class="wd-item" :class="{active:wdId === 4}">
          <i class="iconfont iconxuanzhong"></i>
          <img src="../../assets/img/4.jpg" alt="">
          <div>
            <router-link to="/commonts?id=4">预览</router-link>
            <el-button round type="primary" @click="wdId = 4">使用</el-button>
          </div>
        </div>
        <div class="wd-item" :class="{active:wdId === 5}">
          <i class="iconfont iconxuanzhong"></i>
          <img src="../../assets/img/5.jpg" alt="">
          <div>
            <router-link to="/commonts?id=5">预览</router-link>
            <el-button round type="primary" @click="wdId = 5">使用</el-button>
          </div>
        </div>
        <div class="wd-item" :class="{active:wdId === 6}">
          <i class="iconfont iconxuanzhong"></i>
          <img src="../../assets/img/6.jpg" alt="">
          <div>
            <router-link to="/commonts?id=6">预览</router-link>
            <el-button round type="primary" @click="wdId = 6">使用</el-button>
          </div>
        </div>
      </div>
      <div class="operate">
        <el-button class="operate-next" @click="submitWd">立即提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "orgShop",
  data() {
    return {
      wdId: '',
      state: '',   //  0未提交；1已提交待审核 2审核通过 3：审核未通过 4：锁定
      reason: '',//  未通过原因
    }
  },
  created() {
    this.$emit('setIndex', 0)
    this.getOrgInfo()
  },
  methods: {
    /*
    * 提交网店
    * */
    submitWd(){
      if(!this.wdId){
        this.$message.error('请选择网店模版')
        return
      }
      this.$api.apiContent.shopTijiao({
        token: this.$store.state.user.token,
        shop_id : this.wdId
      }).then(() => {
        this.$message.success('提交成功')
        this.$confirm('机构信息已提交，您是否参加北京市优秀项目征集活动?', '提交成功', {
          confirmButtonText: '参加',
          cancelButtonText: '不参加',
          center: true
        }).then(() => {
          this.$router.push('/home/addOrg')
        }).catch(() => {
          this.showTio()
        });

      }).catch(e => {
        this.$message.error(e.msg)
      })
    },

    showTio(){
      this.$alert('<p style="font-size: 16px;">感谢您的支持！如有任何需求，请联系我们：<br/><span style="color: #f9aa0d;">技术支持： 13581851296</span></p>', '温馨提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        center: true
      }).then(() => {
        this.$router.push('/home/orgInfo')
      });
    },
    /*
    *   获取机构基本信息
    * */
    getOrgInfo() {
      this.$api.apiContent.orgInfo({
        token: this.$store.state.user.token,
      }).then(res => {
        this.state = res.data.base_info.status
        this.reason = res.data.base_info.reason
        this.wdId = res.data.base_info.shop_id
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.content-info {
  min-height: 950px;
  .form-title {
    height: 56px;
    padding: 0 30px;
    border-bottom: 2px solid #f2f2f2;
    position: relative;
    font-size: 18px;

    &:before {
      position: absolute;
      top: 17px;
      left: 15px;
      content: '';
      width: 6px;
      height: 22px;
      background-color: #f9aa0d;
    }

    span {
      font-size: 16px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #999999;
    }

    p {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;

      b {
        color: #c70005;
      }
    }
  }

  .form-step {
    padding: 20px 40px;

    span {
      width: 180px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #999999;
      background-color: #e8e8e8;
      border-radius: 21px;

      &.active {
        background-color: #f9aa0d;
        color: #fff;
      }
    }
  }

  .wd-list {
    flex-wrap: wrap;

    .wd-item {
      width: 30%;
      margin: 30px 0;
      padding: 20px;
      position: relative;
      border-radius: 20px;
      border: 1px solid transparent;

      i {
        display: none;
      }

      &.active {
        border: 1px solid #f9aa0d;

        i {
          display: block;
          position: absolute;
          top: 20px;
          right: 20px;
          color: #f9aa0d;
          font-size: 24px;
        }
      }

      img {
        display: block;
        width: 80%;
        height: 400px;
        margin: 0 auto;
      }

      div {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: 20px 0 0;

        .el-button {
          width: 30%;
          padding: 12px 0;
          background: #f9aa0d;
          border: 1px solid #f9aa0d;
        }

        a {
          display: block;
          width: 30%;
          height: 40px;
          text-align: center;
          line-height: 38px;
          border: 1px solid #f9aa0d;
          color: #f9aa0d;
          border-radius: 20px;
          font-weight: 500;

        }
      }
    }
  }

  .operate {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-bottom: 50px;

    .operate-submit {
      width: 150px;
      height: 60px;
      background-color: #0087d4;
      border-radius: 30px;
      font-size: 16px;
      line-height: 30px;
      color: #ffffff;
    }

    .operate-next {
      width: 314px;
      height: 60px;
      margin-left: 50px;
      background-image: linear-gradient(90deg,
        #f9aa0d 0%,
        #e44730 100%),
      linear-gradient(
          #f9aa0d,
          #f9aa0d);
      background-blend-mode: normal,
      normal;
      border-radius: 30px;
      font-size: 16px;
      line-height: 30px;
      color: #ffffff;
    }
  }

  .step-solid {
    border-bottom: 1px solid #f2f2f2;
  }
}
</style>
